import { useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import styles from './BlogHead.module.scss';
import { blogSearch } from '../../../store/blogFilters';
import useDebouncedCallback from '../../../useDebounceCallback';
import Button, { ButtonVariants } from '../../../components/Button';

const BlogSearch = ({ popularSearched }: { popularSearched: string[] }) => {
  const [search, setSearch] = useAtom(blogSearch);
  const [currentValue, setCurrentValue] = useState<string>('');

  const handleStartSearch = useDebouncedCallback(() => setSearch(currentValue), 500);

  const handlePopularSearched = (value: string) => {
    setSearch(value);
    setCurrentValue(value);
  };

  const clearSearch = () => {
    setCurrentValue('');
  };

  useEffect(() => {
    if (search !== currentValue) {
      handleStartSearch();
    }
  }, [search, currentValue]);

  return (
    <div className={styles.searchBlock}>
      <div className={styles.inputWrapper}>
        <input
          type='search'
          className={styles.searchInput}
          value={currentValue}
          onChange={e => setCurrentValue(e.target.value)}
          placeholder='Blog Search'
        />
        {!currentValue ? (
          <svg className={styles.searchIcon}>
            <use
              href='/media/search.svg#searchSVG'
              xlinkHref='/media/search.svg#searchSVG'
            />
          </svg>
        ) : (
          <Button
            variant={ButtonVariants.TRANSPARENT}
            className={styles.clearButton}
            onClick={clearSearch}
          >
            <svg className={styles.clearIcon}>
              <use
                href='/media/close.svg#closeSVG'
                xlinkHref='/media/close.svg#closeSVG'
              />
            </svg>
          </Button>
        )}
      </div>
      <div className={styles.popularSearched}>
        {popularSearched.map(item => (
          <button
            type='button'
            key={item}
            className={styles.popularSearchItem}
            onClick={() => handlePopularSearched(item)}
          >
            {item}
          </button>
        ))}
      </div>
    </div>
  );
};

export default BlogSearch;
